import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["mousedown", "keydown", "scroll", "touchstart"];
const TIMEOUT_MS = 20 * 60 * 1000;
const REFRESH_AFTER = 5 * 60 * 1000;

export default function useInactivityLogout({ enabled, onTimeout, onActivity }) {
  const timerRef = useRef(null);
  const lastRefreshRef = useRef(Date.now());

  useEffect(() => {
    if (!enabled) return;

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onTimeout && onTimeout();
      }, TIMEOUT_MS);
      const now = Date.now();
      if (now - lastRefreshRef.current > REFRESH_AFTER) {
        lastRefreshRef.current = now;
        onActivity && onActivity();
      }
    };

    ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [enabled, onTimeout, onActivity]);
}
